import {
  SprayCan, Droplets, Brush, Sparkles,
  Headphones, Speaker, Smartphone, Video,
  Camera, Radio, PhoneCall,
  Plug, Wrench,
  Utensils, Flower2, LayoutGrid, Shirt,
  Gem, Dumbbell,
  type LucideIcon,
} from "lucide-react";
import { categoryCovers } from "@/data/categoryImages";

export type SubLink = { name: string; slug: string; Icon: LucideIcon };
export type TopCategory = {
  name: string;
  slug: string;
  image_url: string;
  description: string;
  subcategories: SubLink[];
};

export const topCategories: TopCategory[] = [
  {
    name: "Drogerija",
    slug: "drogerija",
    image_url: categoryCovers["drogerija"],
    description: "Čistila, pripomočki za čiščenje in izdelki za osebno nego preverjenih ponudnikov.",
    subcategories: [
      { name: "Nega doma", slug: "nega-doma", Icon: SprayCan },
      { name: "Čistila", slug: "cistila", Icon: Droplets },
      { name: "Krpe za čiščenje", slug: "krpe-za-ciscenje", Icon: Brush },
      { name: "Osebna nega", slug: "osebna-nega", Icon: Sparkles },
    ],
  },
  {
    name: "Elektronika & avdio",
    slug: "elektronika-avdio",
    image_url: categoryCovers["elektronika-avdio"],
    description: "Slušalke, zvočniki, kamere in zabavna elektronika za vsakdanjo rabo.",
    subcategories: [
      { name: "Slušalke", slug: "slusalke", Icon: Headphones },
      { name: "Prenosni zvočniki", slug: "prenosni-zvocniki", Icon: Speaker },
      { name: "Avdio & video", slug: "avdio-video", Icon: Video },
      { name: "Telefonija", slug: "telefonija", Icon: Smartphone },
    ],
  },
  {
    name: "Avto elektronika",
    slug: "avto-elektronika",
    image_url: categoryCovers["avto-elektronika"],
    description: "Avtomobilske kamere, prostoročni sistemi in FM oddajniki za varno vožnjo.",
    subcategories: [
      { name: "Avto-kamere", slug: "avto-kamere", Icon: Camera },
      { name: "Prostoročno telefoniranje", slug: "prostorocno-telefoniranje", Icon: PhoneCall },
      { name: "FM radiji", slug: "fm-radiji", Icon: Radio },
    ],
  },
  {
    name: "Avtomobilska oprema",
    slug: "avtomobilska-oprema",
    image_url: categoryCovers["avtomobilska-oprema"],
    description: "Polnilci, nosilci in držala, ki jih v avtu uporabljate vsak dan.",
    subcategories: [
      { name: "Napajalniki in polnilci", slug: "napajlniki-in-polnilci", Icon: Plug },
      { name: "Nosilci in držala", slug: "nosilci-in-drzala", Icon: Wrench },
    ],
  },
  {
    name: "Dom & vrt",
    slug: "dom-vrt",
    image_url: categoryCovers["dom-vrt"],
    description: "Oprema za kuhinjo, dom in vrt — od praktičnih pripomočkov do tekstila.",
    subcategories: [
      { name: "Kuhinja", slug: "kuhinja", Icon: Utensils },
      { name: "Vrt", slug: "vrt", Icon: Flower2 },
      { name: "Stojala", slug: "stojala", Icon: LayoutGrid },
      { name: "Prti", slug: "prti", Icon: Shirt },
    ],
  },
  {
    name: "Moda & dodatki",
    slug: "moda-dodatki",
    image_url: categoryCovers["moda-dodatki"],
    description: "Modni dodatki in nakit iz ponudbe trgovin na kupish.si.",
    subcategories: [
      { name: "Nakit", slug: "nakit", Icon: Gem },
    ],
  },
  {
    name: "Šport in prosti čas",
    slug: "sport-prosti-cas",
    image_url: categoryCovers["sport-prosti-cas"],
    description: "Oprema za aktivnosti na prostem, med njimi športne kamere za snemanje podvigov.",
    subcategories: [
      { name: "Športne kamere", slug: "sportne-kamere", Icon: Dumbbell },
    ],
  },
];
